<!-- global markup for header -->
<header class="header">
	<div class="content">
		<div class="header__block row">
			<div class="header__arrow col image" (click)="handleNavigation()"><img src="/assets/images/header/back-arrow.svg" alt="arrow" /><span style="color: white; font-size: 18px">חזרה</span></div>
			<div class="header__title col">{{ title$ | async }}</div>
			<div class="header__burger col image">
				<!-- <img src="/assets/images/header/burger.svg" alt="burger"> -->
			</div>
		</div>
	</div>
	<div class="report-table__row">
		<div class="header__search header__search_small" style="width: 99%; margin: auto; margin-top: 10px">
			<form [formGroup]="form">
				<input
					class="header__search-input"
					type="text"
					[placeholder]="windowWidth > 768 ? 'חפש לפי שם/קוד לקוח' : 'חפש'"
					formControlName="Search"
					id="search-Input"
					style="text-align: center; direction: rtl"
				/>
			</form>
			<button class="header__clear-icon" (click)="SearchClear()"></button>
			<ng-container *ngIf="walkOrderDisplay$ | async as walkOrder">
				<span class="search-info"> מציג ({{ walkOrder?.length || 0 }}) לקוחות</span>
			</ng-container>
		</div>
	</div>
</header>

<!-- start report table markup -->
<section class="report-table">
	<div class="content">
		<div class="flex-row" style="margin-top: 100px" *ngIf="hasPickedAtLeastOnce">
			<div class="box" *ngIf="form.controls.Agent.value?.length">
				<b>סוכנים</b>
				<span>
					{{ form.controls.Agent.value }}
				</span>
			</div>
			<div class="box">
				<button mat-raised-button color="primary" (click)="mustPickDatePopup = true">אפס</button>
			</div>
			<div class="box">
				<form [formGroup]="checkboxesForm" class="flex gap" dir="rtl">
					<mat-checkbox color="primary" *ngFor="let day of daysArray; index as i" [formControlName]="day">
						{{ i | returnHebrewDate : 'day' }}
					</mat-checkbox>
					<mat-icon [matTooltip]="clientWalkTooltip" matTooltipClass="multiline-tooltip bigger-font-tooltip" color="primary" #walkOrderLegend="matTooltip">info_outline</mat-icon>
				</form>
			</div>
		</div>

		<div class="report-table__row report-table__row_full-width custom-scrollbar" style="margin-right: 0px" [ngStyle]="{ height: tableHeight }">
			<table class="report-table__table" cellspacing="0">
				<ng-container *ngIf="daysHeaders$ | async as days">
					<thead class="report-table__table-head fixed-table-headers">
						<tr>
							<th class="report-table__table-head-name" style="width: 150px">לקוח</th>
							<th class="report-table__table-head-name" style="width: 100px">סוכן</th>
							<ng-container *ngIf="selectedDay$ | async as selectedDay">
								<th
									class="report-table__table-head-name sortable-clickable"
									[ngClass]="{ active: selectedDay.day === day }"
									(click)="toggleDaySelected(day)"
									*ngFor="let day of days"
									style="width: 50px"
								>
									{{ dayToHebrewDay(day) }}
								</th>
							</ng-container>
							<th class="report-table__table-head-name" style="width: 50px">סדר הליכה</th>
						</tr>
					</thead>
					<tbody class="report-table__table-body" *ngIf="AgentIDToName$ | async as agentName">
						<tr *ngFor="let row of walkOrderDisplay$ | async; trackBy: trackBy">
							<td class="report-table__table-body-name" style="word-break: break-all">{{ row.ClientID }} - {{ row.ClientName }}</td>
							<td class="report-table__table-body-name">{{ agentName[row.AgentID] }}</td>
							<td class="report-table__table-body-name clickable" *ngFor="let day of days; index as i; last as last" [ngClass]="{ lastDay: last }" (click)="handleDayClick(row, day)">
								{{ row[day] !== '0' ? row[day] : '' }}
							</td>
							<td class="report-table__table-body-name">{{ row.WalkOrder !== '0' ? row.WalkOrder : '' }}</td>
						</tr>
					</tbody>
				</ng-container>
			</table>
		</div>
	</div>
</section>
<!-- end report table markup -->

<div class="popup" *ngIf="mustPickDatePopup" style="z-index: 555">
	<div class="overlay"></div>
	<!-- <div class="product-detail__title" *ngIf="selectedTeudaToOpenPopup?.Client_Name">
		{{ selectedTeudaToOpenPopup?.Client_Name }}
	</div> -->
	<!-- <div class="product-detail__title remarks" *ngIf="remarks.length && !isRemarkPopupOpen"><button mat-raised-button color="primary" (click)="isRemarkPopupOpen=true;">הצג הערות</button></div> -->
	<div class="product-detail-popup popup__content">
		<div class="popup__close" (click)="handleClosePopup()" style="width: 30px; height: 30px; background-color: black"></div>
		<div class="product-detail__wrapper" *ngIf="!loadingMainQuery; else elseBlock">
			<h3 style="text-align: center">בחר סוכנים</h3>

			<form [formGroup]="form" dir="rtl" (ngSubmit)="handleFormSubmit()" class="flex flex-column gap">
				<div class="report-table-popup__box" *ngIf="isAdmin">
					<div class="report-table-popup__row report-table-popup__row_space-between report-table-popup__row_no-border" *ngIf="!loadingAgents; else loadingAgentsBlock">
						<form [formGroup]="form" style="width: 100%">
							<mat-form-field color="primary" appearance="fill" dir="rtl" style="width: 100%">
								<mat-label>סוכנים</mat-label>
								<mat-select formControlName="Agent" multiple>
									<mat-option *ngFor="let a of AgentArray$ | async" [value]="a.AgentID">{{ a.AgentID + ' - ' + a.UserName }}</mat-option>
								</mat-select>
							</mat-form-field>
						</form>
					</div>
					<ng-template #loadingAgentsBlock>
						<ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
					</ng-template>
				</div>

				<button mat-raised-button color="primary" [disabled]="loadingAgents && isAdmin">בחר</button>
			</form>
		</div>
		<ng-template #elseBlock>
			<div class="product-detail__wrapper flex flex-column justify-align-center rtl">
				<h2>טוען, אנא המתינו...</h2>
				<mat-spinner diameter="50" color="primary"></mat-spinner>
			</div>
		</ng-template>
	</div>
</div>
